import { render, staticRenderFns } from "./UpdatesPanel.vue?vue&type=template&id=8267fe5c&"
import script from "./UpdatesPanel.vue?vue&type=script&lang=ts&"
export * from "./UpdatesPanel.vue?vue&type=script&lang=ts&"
import style0 from "./UpdatesPanel.vue?vue&type=style&index=0&id=8267fe5c&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports